import { Controller } from "@hotwired/stimulus";

// Empties a field from a button beside it, such as the note editor's Date (a native date input has
// no reliable clear control of its own across browsers).
export default class extends Controller {
  static targets = ["input"];

  clear() {
    this.inputTarget.value = "";
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.inputTarget.focus();
  }
}
